import React from 'react';
import { useDebouncedCallback, Options } from 'use-debounce';

function useDebouncedState<T>(
  vDefault: T | (() => T),
  duration = 250,
  options?: Options
): [T, (v: T) => void] {
  const [v, setVState] = React.useState<T>(vDefault);
  const debouncedCallback = useDebouncedCallback(setVState, duration, {
    leading: false,
    trailing: true,
    ...options,
  });

  return [v, debouncedCallback];
}

export default useDebouncedState;
